import React from 'react';
import { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DocumentCard from './DocumentCard'; // Assuming you have a DocumentCard component
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

const darkThemeModal = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "#ooo",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#ccc",
    minWidth: "50%", // Increased width
    maxWidth: "80%", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#444",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
}

const SelectIndicatorModal = ({ open, handleClose, modalId, handleChangeInput, handleClickSelectIndicator, indicatorsList}) => {
  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      sx={darkThemeModal.modal}
      id= {modalId} 
    >

      <Fade in={open}>
        <Box sx={darkThemeModal.modalContent} >
        <div className="modal-dialog modal-dialog-centered">
            <div className="border modal-content-1 upgrade-modal-content  login_modal_wrapper  min-height-bookmark " >
              <div className="modal-body text-center">
                <div className="dropdown-search-dashboard">
                  <div className="search-input-wrapper">
                    <input className="modal-input" type="text" placeholder="Enter Indicator Name" onChange={handleChangeInput}/>
                  </div>
                  <div  className="dropdown-content">
                    <Box sx={{cursor:"pointer"}}>
                        {Object.keys(indicatorsList)?.map((indicator) => (
                          <a key={indicator} id={indicator} onClick={handleClickSelectIndicator} className="indicator-list-a">{indicator} </a>
                    ))}
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SelectIndicatorModal;